import React, { FC, memo } from 'react';
import styled from 'styled-components/native';

import { ICountryStoneinnoDetail } from '@webtrader/core/api/account/country-stoneinno';
import { EDataTestId } from '@webtrader/core/constants/test';
import dynamicSize from '@webtrader/core/dynamic-size';

import ActionSheetCheckmark from '@/components/ActionSheet/Checkmark';
import Text from '@/components/Text';
import TouchableOpacity from '@/components/Touch/Opacity';

interface IProps {
  country: ICountryStoneinnoDetail;
  selected?: boolean;
  onSelect: (countryId: number) => void;
}

const SignUpFormCountrySelector: FC<IProps> = (props) => {
  const { country, selected, onSelect } = props;

  const { country: countryName, id } = country;

  const onSelectCountry = () => onSelect(id);

  return (
    <CountrySelector
      selected={selected}
      activeOpacity={1}
      onPress={onSelectCountry}
      testID={EDataTestId.SIGN_UP_COUNTRY_OPTION}
      accessibilityState={{ selected }}
      accessibilityLabel={countryName}
    >
      <CountrySelectorText>{countryName}</CountrySelectorText>
      <CountrySelectorIcon>{selected && <ActionSheetCheckmark />}</CountrySelectorIcon>
    </CountrySelector>
  );
};

export default memo(SignUpFormCountrySelector);

const CountrySelector = styled(TouchableOpacity)<{ selected?: boolean }>`
  height: ${dynamicSize.convertSize(40)}px;
  padding: 0px ${dynamicSize.convertSize(12)}px;

  align-items: center;
  flex-direction: row;
  justify-content: space-between;

  background-color: ${({ theme, selected }) => theme.colors.background[selected ? 1 : 0]};
`;

const CountrySelectorText = styled(Text)`
  font-size: ${dynamicSize.convertSize(15)}px;
`;

const CountrySelectorIcon = styled.View`
  font-size: ${dynamicSize.convertSize(15)}px;
`;
